<template>
  <div class="line_chart_wrap">
    <div class="chart_title mt-5" v-if="Boolean(chartData.title)">
      <div class="text-h6"><v-icon>mdi-circle-small</v-icon>{{ $i18n.translate(chartData.title) }}</div>
    </div>
    <v-row class="mt-0">
      <v-col v-if="Boolean(computeSummary)" class="summary-item active" cols="4" style="border:none;">
        <div v-if="isDisplayMyData" class="mb-10">
          <div class="status">
            <div :class="displayStatus"></div>
          </div>
          <div class="text">
            <div>{{displayMyTotal}}</div>
          </div>
        </div>

        <div class="text">
          <p>{{ $i18n.translate('평균참여율') }}</p>
          <p v-for="(d, j) in displayTotalAvg" :key="j">
            {{d.label}} - {{d.rate}}%
          </p>
        </div>
      </v-col>
      <v-col>
        <Bar
            :chart-options="chartOptions"
            :chart-data="chartData"
            :chart-id="chartId"
            :dataset-id-key="datasetIdKey"
            :plugins="plugins"
            :css-classes="cssClasses"
            :styles="styles"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { Chart , Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import  ChartDataLabels from 'chartjs-plugin-datalabels';
import UT from "@/common/util";

Chart.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ChartDataLabels)
export default {
  name: 'StackChart',
  components: { Bar },
  props: {
    chartData:{
      type: Object,
      default: () => {}
    },
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 100
    },
    cssClasses: {
      default: '',
      type: String
    },
    plugins: {
      type: Object,
      default: () => {}
    }

  },
  computed: {
    styles () {
      let len = this.chartData.labels ? this.chartData.labels.length : 1;
      return {
        height: `${len * 50 + 20}px`,
      }
    },
    computeSummary() {
      if (!this.chartData.summary) {
        return null;
      }
      return {
        myTotal: this.chartData.summary.total,
        myDone: this.chartData.summary.done,
        displayMyData: this.chartData.summary.displayMyData,
      }
    },
    isDisplayMyData() {
      let s = this.computeSummary;
      return s.displayMyData;
    },
    computeMyAvg() {
      let s = this.computeSummary;
      return s.myTotal === 0 ? 0 : UT.toFixed(s.myDone / s.myTotal * 100, 2);
    },
    displayMyTotal() {
      return `내 참여율 : ${this.computeMyAvg}%`;
    },
    displayStatus() {
      if (!this.computeSummary.myTotal) {
        return "smile";
      }
      return this.computeMyAvg > 50 ? "smile" : "crying";
    },
    displayTotalAvg() {
      if (!this.chartData) {
        return null;
      }
      let list = [];
      this.chartData.labels.forEach((row, i) => {
        let done = this.chartData.datasets[0].data[i];
        let todo = this.chartData.datasets[1].data[i];
        let total = done + todo;
        list.push({
          label: row,
          rate: total === 0 ? 0 : UT.toFixed(done / total * 100, 2)
        });
      });
      return list;
    }
  },
  data() {
    let unitX = this.chartData.unitX || '';
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        scales: {
          x: {
            stacked: true, //누적 막대 그래프
            display: true, //그리드 선
            ticks: {
              display: true,
              callback: function(value) {  //축 뒤에 % 표시 포맷
                return `${value}${unitX}`;
              }
            }
          },
          y: {
            stacked: true,
            display: true,
            ticks: {
              display: true,
            }
          },
        },
        layout: {
          padding: 0
        },
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'center',
            align: 'center',
          },
        },
      }
     }
  }
}
</script>


<style scoped>

</style>
